import React, { useState, useEffect } from "react"

import LogoSvg from "../static/logo.svg"
import SvgFB from '../static/icon-fb-btn.svg';
import HeaderIlustracion from "../static/header_ilustracion.svg"

//import FacebookLogin from 'react-facebook-login';

import { slide as MobileMenu } from 'react-burger-menu'


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
  useLocation
} from "react-router-dom";


import {UserProvider, useUser } from '../context/UserContext'



export default function Header() {
  const [open, setOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();
  let location = useLocation();

  var styles = {
    bmCrossButton : {
      right: "inherit",
      left: "8px"
    },
    bmMenuWrap: {
     width: '100%'
   }
  }

  function handleClickLogout(e) {
    e.preventDefault();
    logout();
    if(location.pathname == '/causas/add')
      window.location.reload();
  }

  function handleMenuClick() {
    setOpen(false);
  }
  function handleStateChange(state) {
    setOpen(state.isOpen);
  }

  function responseFacebook( response ){
    setCargandoUsuario(false);
    setData( response );
    setShowLogin(true)
  }
  return (
    <UserProvider>
      <div className="mobile-menu d-block d-md-none">
        <MobileMenu styles={styles} isOpen={ open } onStateChange={(state) => handleStateChange(state)}>
        <Link to="/"><img src={LogoSvg} alt=""/></Link>
          <span style={{ opacity : cargandoUsuario == true ? 0 : 1 }}>
            { usuario !== null ? <Link to="/causas">Ver causas</Link> : null }
            { usuario === null ? <a href="#" className="fb-btn" onClick={e => { e.preventDefault(); FBLogin();}}><img src={SvgFB} />Ingresar con Facebook</a> : <Link to="/causas/add">Crear causa</Link> }
            { usuario !== null ? <Link to="/mi-perfil"><img src={usuario.profile_image} className="profile_image"/></Link> : null }
            { usuario !== null ? <a href="/logout" onClick={handleClickLogout}>Cerrar sesion</a> : null }
          </span>
        </MobileMenu>
      </div>
      <section id="menu">
          <nav className="header-menu ">

            <div className="header-menu-logo">
              <Link to="/"><img src={LogoSvg} alt=""/></Link>
            </div>

            <div className="header-menu-container">

              <span style={{ opacity : cargandoUsuario == true ? 0 : 1 }}>
                { usuario !== null ? <Link to="/causas">Ver causas</Link> : null }
                { usuario === null ? <a href="#" className="fb-btn" onClick={e => { e.preventDefault(); FBLogin();}}><img src={SvgFB} />Ingresar con Facebook</a> : <Link to="/causas/add">Crear causa</Link> }
                { usuario !== null ? <Link to="/mi-perfil"><img src={usuario.profile_image} className="profile_image"/></Link> : null }
                { usuario !== null ? <a href="/logout" onClick={handleClickLogout}>Cerrar sesion</a> : null }
              </span>
            </div>

          </nav>
      </section>
    </UserProvider>
  )
}
